import { InclusionType } from '../../src/components/public/InclusionsList';
import { LoremIpsum } from 'lorem-ipsum';

const lorem = new LoremIpsum({
  sentencesPerParagraph: {
    max: 8,
    min: 4,
  },
  wordsPerSentence: {
    max: 16,
    min: 4,
  },
});

export const inclusions = [
  {
    label: 'Example Experience',
    description: 'Our partners ensure special health and safety measures to keep you safe.',
    icon: InclusionType.Experience,
    learnMore: 'http://www.google.com',
  },
  {
    label: 'Example COVID19',
    description: lorem.generateParagraphs(1),
    icon: InclusionType.COVID19,
  },
  {
    label: 'Example Transfers',
    description: lorem.generateSentences(1),
    icon: InclusionType.Transfers,
  },
  {
    label: 'Example Flights',
    description: lorem.generateSentences(1),
    icon: InclusionType.Flights,
  },
  {
    label: 'Example Generic',
    description: lorem.generateParagraphs(1),
    icon: InclusionType.Generic,
  },
  {
    label: 'Example Stay',
    description: lorem.generateSentences(1),
    icon: InclusionType.Stay,
  },
  {
    label: 'Example Generic',
    description: lorem.generateSentences(1),
    icon: InclusionType.Generic,
  },
  {
    label: 'Example Flights',
    description: lorem.generateSentences(1),
    icon: InclusionType.Flights,
  },
  {
    label: 'Example Transfers',
    description: lorem.generateParagraphs(1),
    icon: InclusionType.Transfers,
  },
  {
    label: 'Example Transfers',
    description: lorem.generateSentences(1),
    icon: InclusionType.Transfers,
  },
];
